import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'tree-menu-loading-state',
    props: {
        levelOneCount: {
            default: 0
        },
        levelTwoCount: {
            default: 0
        },
        levelThreeCount: {
            default: 0
        }
    },
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock(_Fragment, null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levelOneCount, (level1)=>{
                    return _openBlock(), _createElementBlock("div", {
                        key: level1,
                        class: "tw-flex tw-items-center tw-space-x-4 tw-py-1 tw-animate-pulse",
                        "data-testid": "tree-menu-loading-state"
                    }, _cache[0] || (_cache[0] = [
                        _createElementVNode("div", {
                            class: "tw-flex-1 tw-py-2"
                        }, [
                            _createElementVNode("div", {
                                class: "tw-h-4 tw-bg-gray-200 tw-rounded tw-w-3/4"
                            })
                        ], -1)
                    ]));
                }), 128)),
                _cache[4] || (_cache[4] = _createTextVNode()),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levelTwoCount, (level2)=>{
                    return _openBlock(), _createElementBlock("div", {
                        key: level2,
                        class: "tw-p-4 tw-max-w-sm tw-mx-auto"
                    }, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", {
                            class: "tw-flex tw-items-center tw-space-x-4 tw-animate-pulse"
                        }, [
                            _createElementVNode("div", {
                                class: "tw-w-4 tw-h-4 tw-rounded tw-bg-gray-200"
                            }),
                            _createTextVNode(),
                            _createElementVNode("div", {
                                class: "tw-flex-1 tw-py-1"
                            }, [
                                _createElementVNode("div", {
                                    class: "tw-h-4 tw-bg-gray-200 tw-rounded tw-w-3/4"
                                })
                            ])
                        ], -1)),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levelThreeCount, (level3)=>{
                            return _openBlock(), _createElementBlock("div", {
                                key: level3,
                                class: "tw-ml-6"
                            }, _cache[1] || (_cache[1] = [
                                _createElementVNode("div", {
                                    class: "tw-flex tw-items-center tw-space-x-4 tw-animate-pulse tw-mt-2"
                                }, [
                                    _createElementVNode("div", {
                                        class: "tw-w-4 tw-h-4 tw-rounded tw-bg-gray-200"
                                    }),
                                    _createTextVNode(),
                                    _createElementVNode("div", {
                                        class: "tw-flex-1 tw-py-1"
                                    }, [
                                        _createElementVNode("div", {
                                            class: "tw-h-4 tw-bg-gray-200 tw-rounded tw-w-5/6"
                                        })
                                    ])
                                ], -1)
                            ]));
                        }), 128))
                    ]);
                }), 128))
            ], 64);
        };
    }
});
